import { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { MenuItem, Row } from '@tempmee/react';

interface IAccountMenuItemProps {
  /** Visible label. */
  text: string;
  /** `data-cy` hook consumed by the E2E suite. */
  dataCy: string;
  /** Route to navigate to (client-side). Omit for an action-only item. */
  to?: string;
  /** Analytics/side-effect handler for links, or the action for a plain item. */
  onClick?: () => void;
  /** Optional trailing content, e.g. a status warning icon. */
  endAdornment?: ReactNode;
}

/**
 * A single row in the Account menu, rendered with the design-system `MenuItem`.
 * It renders a `<button>` (not an `<a href>`) so navigation stays client-side
 * via `useNavigate` instead of triggering a full page reload.
 */
export const AccountMenuItem = ({
  text,
  dataCy,
  to,
  onClick,
  endAdornment,
}: IAccountMenuItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    onClick?.();
    if (to) navigate(to);
  };

  return (
    <MenuItem className="font-bold hover:bg-transparent" data-cy={dataCy} onClick={handleClick}>
      {endAdornment ? (
        <Row align="center" gap={2}>
          {text}
          {endAdornment}
        </Row>
      ) : (
        text
      )}
    </MenuItem>
  );
};
